import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import CatalogFiltersTags from "../catalog-filters-tags/catalog-filters-tags.component";
import CatalogMain from "./catalog-main";

import {
  GET_COLLECTIONS,
  GET_ITEMS_WITH_FILTERS,
} from "../../../queries/queries";
import { GET_ACTIVE_USER } from "../../../queries/auth.queries";

import { FilterContext } from "../../../context/filterContext";
import "./catalog-main.css";
import useLocationFromSession from "../../../shared/hooks/useLocationFromSession";
import CatalogSkeleton from "../CatalogSkeleton";
import FiltersSkeleton from "../FilterSkeleton";

const CollectionsOverviewContainer = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();

  const { searchState, setSearchState } = useContext(FilterContext);

  let { term, facetValueIds, collectionId, sort } = searchState;

  const factValuesIds = facetValueIds.map((fv) => fv.id);
  const collectionIds = collectionId ? collectionId["id"] : null;

  const [state, setState] = useState({
    bottom: false,
  });

  let search = new URLSearchParams(location.search).get("search");
  let category = new URLSearchParams(location.search).get("category");
  let facets = new URLSearchParams(location.search).get("facets");

  const { loading: userLoader } = useQuery(GET_ACTIVE_USER);
  const { data: colleactionsData, loading: collectionLoader } =
    useQuery(GET_COLLECTIONS);

  useEffect(() => {
    if (search && search !== "undefined") {
      setSearchState({
        ...searchState,
        term: search,
        previousPage: location?.pathname,
      });
    }
    if (category && category !== "undefined") {
      const col = colleactionsData?.collections?.items.filter(
        (c) => c?.id === category
      );

      if (col && col.length) {
        setSearchState({
          ...searchState,
          facetValueIds: [],
          collectionId: col[0],
          facetFaluesPerCollectionInit: true,
          previousPage: location?.pathname,
        });
      }
    }
    if (facets && facets !== "undefined") {
      // setSearchState({
      //   ...searchState,
      //   facetValueIds: facets,
      //   previousPage: location?.pathname
      // });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, category, facets, colleactionsData]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const { queryLocation, isLocationValid } = useLocationFromSession();
  const { loading, error, data } = useQuery(GET_ITEMS_WITH_FILTERS, {
    // skip: !isLocationValid,
    variables: {
      term,
      facetValueIds: factValuesIds,
      collectionId: collectionIds,
      groupByProduct: !searchState?.term?.trim(),
      sort,
      location: isLocationValid ? queryLocation : null,
    },
  });

  if (error) return `Error! ${error.message}`;

  const items = data?.search?.items;

  if (loading || collectionLoader || userLoader) {
    return (
      <div className="catalog-main-skeleton">
        <div className="catalog-main-skeleton-res">
          <FiltersSkeleton />
        </div>
        <div className="catalog-main__items">
          <CatalogSkeleton count={12} />
        </div>
      </div>
    );
  }

  if (!items?.length) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "Barlow",
        }}
      >
        {t("catalog.noItemsAvailable")}
      </div>
    );
  }

  return (
    <>
      <CatalogFiltersTags className="catalog-main__back-home-btn" />
      <div className="catalog-main__gap-divider"></div>
      <CatalogMain
        items={items}
        toggleDrawer={toggleDrawer}
        state={state}
        setState={setState}
        loading={loading}
      />
    </>
  );
};

export default CollectionsOverviewContainer;
